import React from 'react';
import Courses from '../components/Courses/Courses.js'
import Curriculum from '../components/Courses/Curriculum.js';


const Course = () => {
  return (
    <div>
        <Curriculum/>
        <Courses/>


    </div>
  );
};

export default Course;
